const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('flarum-messages', 'forum/components/DialogsDropdown');